module.exports = __webpack_public_path__ + "img/redcompra.e037a7f.png";